import * as XLSX from 'xlsx';

export function exportParticipantsToExcel(participants) {
    const data = participants.map((p) => ({
        Name: p.name,
        Nickname: p.nickname,
        Email: p.email,
        Phone: p.mobile_number,
        SSN: p.ssn,
        Active: p.active ? 'Yes' : 'No',
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Participants');

    XLSX.writeFile(workbook, 'participants.xlsx');
}
